import { normalizeStoredAvatarUrl } from '@/lib/avatarPublic';

export async function getUserSession() {
  const res = await fetch('/api/user/session', { credentials: 'include' });
  if (!res.ok) {
    return {
      ok: false,
      userId: null,
      username: null,
      email: null,
      name: null,
      preferredTheme: 'dark',
      preferredLanguage: 'English (EN)',
      avatarUrl: '',
    };
  }
  const data = await res.json().catch(() => ({}));
  const preferredTheme = data.preferredTheme === 'light' ? 'light' : 'dark';
  return {
    ok: true,
    userId: typeof data.userId === 'string' ? data.userId : null,
    username: typeof data.username === 'string' ? data.username : null,
    email: typeof data.email === 'string' ? data.email : null,
    name: typeof data.name === 'string' ? data.name : '',
    preferredTheme,
    preferredLanguage:
      typeof data.preferredLanguage === 'string' && data.preferredLanguage.trim()
        ? data.preferredLanguage.trim()
        : 'English (EN)',
    avatarUrl:
      normalizeStoredAvatarUrl(typeof data.avatarUrl === 'string' ? data.avatarUrl : '') || '',
  };
}

export async function userLogout() {
  await fetch('/api/user/logout', { method: 'POST', credentials: 'include' });
}
